import { AdminProctorRequestReviewerPermissionGuard } from '@exam-center/admin-proctor-management';
import {
  ExamCenterProctorRequestDetailsReadonlyField,
  ExamCenterProctorRequestVerdictFormProvider,
  ExamCenterProctorRequestVerdictSelection,
  useAdminExamCenterProctorRequestDetails,
} from '@exam-center/proctor-request-management';
import { Flex } from '@shared/components';

export default function AdminProctorRequestDetailsPage() {
  const {
    examCenterProctorRequest: { step },
  } = useAdminExamCenterProctorRequestDetails();

  return (
    <AdminProctorRequestReviewerPermissionGuard currentStep={step}>
      <ExamCenterProctorRequestVerdictFormProvider>
        <Flex
          sx={(theme) => ({
            flex: 1,
            gap: theme.spacing(6),
            flexDirection: 'column',
          })}
        >
          <ExamCenterProctorRequestDetailsReadonlyField />
          <ExamCenterProctorRequestVerdictSelection />
        </Flex>
      </ExamCenterProctorRequestVerdictFormProvider>
    </AdminProctorRequestReviewerPermissionGuard>
  );
}
